import React from "react";
import "./style.scss";

const OptionButtons = ({ selected, onSelect }) => {
  const isYesSelected = selected === "Yes";

  return (
    <div className="options__btn">
      <button
        className={`option__btn ${isYesSelected ? "selected" : ""}`}
        onClick={() => onSelect("Yes")}
      >
        Yes
      </button>
      <button
        className={`option__btn ${selected === "No" ? "selected" : ""}`}
        onClick={() => onSelect("No")}
      >
        No
      </button>
    </div>
  );
};

export default OptionButtons;
